<template>
  <div class="row">
    <div v-if="!$store.state.auth.is_authenticated" class="col-12 pb-3">
      <a v-bind:href="homeDomain" class="fc-a-logo fc-a-logo--noauth">
        <img
          class="fc-a-logo__image"
          alt="Fantasy Congress Logo"
          src="@/assets/images/logo-centered.png"
        />
      </a>
    </div>
    <div class="col-12">
      <article class="fc-m-container fc-signup">
        <h2>Educator Sign Up</h2>

        <form>
          <div class="form-group">
            <label for="username">Username *</label>
            <input
              v-model="username"
              class="form-control"
              type="text"
              name="username"
              value=""
            />
          </div>
          <div class="form-group">
            <label for="email">Email *</label>
            <input
              v-model="email"
              class="form-control"
              type="email"
              name="email"
              value=""
            />
          </div>
          <div class="form-group">
            <label for="password1">Password *</label>
            <input
              v-model="password1"
              class="form-control"
              type="password"
              name="password1"
              value=""
            />
          </div>
          <div class="form-group">
            <label for="password2">Confirm Password *</label>
            <input
              v-model="password2"
              class="form-control"
              type="password"
              name="password2"
              value=""
            />
          </div>
          <div class="form-group">
            <p class="small">
              Your subscription is automatically renewed one year from the date
              of purchase unless you cancel. You can cancel any time by visiting
              your account settings.
            </p>
          </div>

          <div class="form-group">
            <label for="referral_code">Referral Code</label>
            <input
              v-model="referralCode"
              class="form-control"
              type="text"
              name="referral_code"
              value=""
            />
            <p class="small">
              Get $50 off your first year of Fantasy Congress when referred by
              an existing customer. (Price below does not update. Discount will
              appear on checkout page.)
            </p>
          </div>

          <!-- Used to display Element errors. -->
          <p>Total: <strong>$149/year</strong></p>
          <loader v-if="submitted" v-bind:embeded="true"></loader>
          <button v-else @click="signupSubmit" class="btn btn-primary">
            Continue
          </button>
        </form>
        <div class="mt-4 small">
          Already have an account? 
          <router-link
            to="/login"
            class="fc-a-link--casual"
          >
              Login
          </router-link>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";



export default {
  name: "Signup",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      username: "",
      email: "",
      password1: "",
      password2: "",
      referralCode: "",
      signupActive: false,
      submitted: false,
      price: "",
      homeDomain: process.env.VUE_APP_HOME_DOMAIN
    };
  },
  created: function() {

    if (this.$store.state.auth.is_authenticated == true) {
      this.$router.push("/leagues");
    } else {
      const csrftoken = getCookie("csrftoken");

    }

  },
  methods: {
    handleErrors: function(errors) {
      let app = this;
      let errorFields = Object.keys(errors);
      for (let i = 0; i < errorFields.length; i++) {
        for (let x = 0; x < errors[errorFields[i]].length; x++) {
          let field = errorFields[i];
          if (field.search("password") != -1) {
            field = field == "password2" ? "confirm password" : "password";
          }
          app.$store.commit("alert/addMessage", {
            message: `${field}: ${errors[errorFields[i]][x]}`,
            class: "danger",
            persist: false
          });
        }
      }
    },
    signupSubmit: function(e) {
      e.preventDefault();
      let app = this;
      app.submitted = true;
      app.referralCode = app.referralCode.trim();

      const csrftoken = getCookie("csrftoken");
      let status = null;
      let form = new URLSearchParams({
        username: app.username,
        email: app.email,
        password1: app.password1,
        password2: app.password2,
        referral_code: app.referralCode,
        plan: "educational"
      });

      fetch(`${process.env.VUE_APP_PLATFORM}/signup/customer/`, {
        credentials: "include",
        method: "POST",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      })
        .then(function(response) {
          app.$store.commit("alert/deletePageMessages");
          status = response.ok;
          return response.json();
        })
        .then(function(response) {
          if (status ) {

            window.location.href = response.checkout_url;

          } else {
            app.handleErrors(response.errors);
          }
        })
        .catch((error) => {
          app.$store.commit("alert/addMessage", {
            message: `error: Something went wrong. Please refresh and try again.`,
            class: "danger",
            persist: false
          });

          app.$store.commit("alert/addMessage", {
            message: `error: ${error}.`,
            class: "danger",
            persist: false
          });
        })
        .finally(() => {
          app.submitted = false;
        });
        
    }
  }
};
</script>
<style scoped>
.fc-signup {
  margin: auto;
  max-width: 500px;
}

.fc-a-link--warning {
  color: #9d7d1c;
  text-decoration: underline;
}
.fc-a-link--warning:hover {
  color: #00b1ef;
  text-decoration: none;
}
.fc-signup-1 {
  border-right: 0px;
}

@media (min-width: 768px) {
  .fc-signup-1 {
    border-right: 1px solid #d2d3d4;
  }
}
</style>
